module.exports = __webpack_public_path__ + "img/pdf-icon.627b3749.svg";